var _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconHamburger = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  className: "icon icon--menu",
  ref: svgRef
}, props), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 3,
  y1: 12,
  x2: 21,
  y2: 12
})), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
  x1: 3,
  y1: 6,
  x2: 21,
  y2: 6
})), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
  x1: 3,
  y1: 18,
  x2: 21,
  y2: 18
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconHamburger, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/IconHamburger.f675c3ab.svg";
export { ForwardRef as ReactComponent };